import ready from "./lib/ready";
import fd from "./lib/promise-fastdom";
import promiseIdle from "./lib/promise-idle";
import RollingNumber from "./lib/RollingNumber";
import promiseRAF from "./lib/promise-raf";
import {delegate} from "./lib/events";

ready().then(function () {
    fd.mutate(function () {
        document.body.classList.remove('loading');
    }).then(() => {
        Array.prototype.map.call(document.querySelectorAll('.lylan-numbers__item'), function (node) {
            const number = node.querySelector('.lylan-numbers__number');
            node._rolling_number = new RollingNumber(number);
            Promise.resolve(promiseIdle()).then(() => {
                node._rolling_number.init();
            });
        });
        document.addEventListener('reveal/on', delegate('.lylan-numbers__item', function () {
            Promise.resolve().then(promiseRAF(10))
                .then(() => this._rolling_number.roll())
            ;
        }));
    });
});